import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import jizhang from '@/components/jizhang'
import gongshang from '@/components/gongshang'
import shuiwu from '@/components/shuiwu'
import zhichan from '@/components/zhichan'
import xuke from '@/components/xuke'
import renshi from '@/components/renshi'
import xueyuan from '@/components/xueyuan'
import xinxi from '@/components/xinxi'
import contact from '@/components/contact'
import remen from '@/components/remen'
import xinwen from '@/components/xinwen'
import caiwuzhushou from '@/components/caiwuzhushou'
import zhidu from '@/components/zhidu'
import meta from 'vue-meta'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') throw err
  })
}

Vue.use(meta)
Vue.use(Router)
Vue.use(VueRouter)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|办理许可证',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '名企科技是工商局、财政局批复的财税服务平台，具有政府颁发的《代理记账许可证》资质。公司成立于2017年2月，位于北京市核心区-西城区。公司拥有几十项软件著作权，自主研发名企财务助手小程序，可以协助客户计算税费。公司主要业务有：工商注册、代理记账、工商变更、股权变更、注销清算、申请许可证、申请资质、商标代办、高新企业代理申报、社保服务托管、网站建设等服务。'
        }
      }
    },
    {
      path: '/jizhang',
      name: 'jizhang',
      component: jizhang,
      meta: {
        title: '北京代理记账_记账报税_财务外包_会计服务_财务托管_人事服务_名企科技',
        content: {
          keywords: '北京代理记账,记账报税,财务外包,会计服务,小规模记账,一般纳税人记账,税务申报,财务代理',
          description: '名企科技提供专业的代理记账服务，包括小规模纳税人记账、一般纳税人记账、税务申报、财务报表编制、汇算清缴、整理乱账等。具有政府颁发的《代理记账许可证》资质，服务专业规范，价格透明。'
        }
      }
    },
    {
      path: '/gongshang',
      name: 'gongshang',
      component: gongshang,
      meta: {
        title: '北京注册公司_工商注册_营业执照代办_工商变更_公司注销_名企科技',
        content: {
          keywords: '北京注册公司,工商注册,营业执照代办,工商变更,公司注册地址,公司注销,股权变更,法人变更',
          description: '北京名企科技有限公司是专业的财务服务平台，提供北京注册公司、注册地址、工商注册、营业执照代办、工商变更、公司注销、股权变更、公司注销等服务。具有政府批复的代理记账资质，专业高效，快速办理北京各区公司注册业务。'
        }
      }
    },
    {
      path: '/shuiwu',
      name: 'shuiwu',
      component: shuiwu,
      meta: {
        title: '北京税务服务_税务筹划_税务变更_清税注销_代理报税_名企科技',
        content: {
          keywords: '北京税务服务,税务筹划,税务变更,清税注销,税务咨询,纳税申报,税务代理,税收优化',
          description: '北京名企科技有限公司是专业的财务服务平台，提供北京税务服务，包括税务筹划、税务变更、清税注销、纳税申报等。帮助企业合理节税，解决税务疑难问题，合规高效。'
        }
      }
    },
    {
      path: '/zhichan',
      name: 'zhichan',
      component: zhichan,
      meta: {
        title: '北京商标注册_软件著作权_高新企业申请_知识产权代理_审计咨询服务_名企科技',
        content: {
          keywords: '北京商标注册,软件著作权,高新企业申请,知识产权代理,专利申请,版权登记,双软认证',
          description: '北京名企科技有限公司是专业的财务服务平台，提供商标注册、软件著作权登记、高新技术企业申请、专利申请等知识产权服务。拥有几十项软件著作权经验，助力企业保护创新成果。'
        }
      }
    },
    {
      path: '/xuke',
      name: 'xuke',
      component: xuke,
      meta: {
        title: '北京资质代办_许可证办理_ICP许可证_食品经营许可证_体系认证咨询服务_名企科技',
        content: {
          keywords: '北京资质代办,许可证办理,ICP许可证,食品经营许可证,出版物许可证,劳务派遣许可证,医疗器械许可证，体系认证咨询服务',
          description: '名企科技代办各类经营许可证和资质，包括ICP许可证、食品经营许可证、出版物许可证、劳务派遣许可证等。熟悉审批流程，快速高效办理。'
        }
      }
    },
    {
      path: '/renshi',
      name: 'renshi',
      component: renshi,
      meta: {
        title: '北京社保托管_人事代理_社保代缴_公积金代办_名企科技',
        content: {
          keywords: '北京社保托管,人事代理,社保代缴,公积金代办,社保代理,人事服务,劳动关系,薪酬代发,增减员,领取生育津贴,办理退休',
          description: '名企科技提供北京社保托管、人事代理、社保代缴、公积金代办、增减员,领取生育津贴,办理退休等服务。解决企业人事管理难题，降低企业用工成本，合规专业。'
        }
      }
    },
    {
      path: '/xueyuan',
      name: 'xueyuan',
      component: xueyuan,
      meta: {
        title: '财税知识_工商政策_企业管理_创业指南_老板学院_名企科技',
        content: {
          keywords: '财税知识,工商政策,企业管理,创业指南,税务知识,财务知识,创业资讯,政策解读',
          description: '名企科技老板学院提供最新的财税知识、工商政策解读、企业管理经验、创业指南等内容。帮助创业者和企业家掌握实用的财税工商知识。'
        }
      }
    },
    {
      path: '/xinxi',
      name: 'xinxi',
      component: xinxi,
      meta: {
        title: '企业信息化建设_财务软件_企业网站_小程序开发_名企科技_软件外包_系统定制开发_AI系统搭建及实施',
        content: {
          keywords: '企业信息化建设,财务软件,企业网站,小程序开发,企业微信,钉钉部署,软件外包_系统定制开发,信息化解决方案',
          description: '名企科技提供企业信息化建设服务，包括软件开发、企业网站建设、小程序开发、企业微信和钉钉部署、系统定制开发、AI系统搭建及实施等，助力企业数字化转型。'
        }
      }
    },
    {
      path: '/zhidu',
      name: 'zhidu',
      component: zhidu,
      meta: {
        title: '企业制度设计_员工培训_财务制度_人事制度_名企科技',
        content: {
          keywords: '企业制度设计,员工培训,财务制度,人事制度,企业内训,管理制度,合规培训,财务培训',
          description: '名企科技提供企业制度设计与员工培训服务，包括财务制度设计、人事制度建立、企业内训等。帮助企业建立健全的管理体系。'
        }
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact,
      meta: {
        title: '联系我们_名企科技地址电话_北京财务公司联系方式',
        content: {
          keywords: '名企科技电话,名企科技地址,北京财务公司联系方式,代理记账咨询,注册公司咨询',
          description: '联系名企科技，电话：13910303798，地址：北京市西城区西直门外大街1号院2号楼(西环广场T2座)19C2。专业财务税务服务机构，欢迎咨询洽谈。'
        }
      }
    },
    {
      path: '/remen',
      name: 'remen',
      component: remen,
      meta: {
        title: '热门服务_注册公司_代理记账_资质许可_名企科技_社保公积金托管_软件开发外包',
        content: {
          keywords: '热门服务,注册公司,代理记账,资质许可,工商代办,税务服务,系统建设,企业一站式服务',
          description: '名企科技是专业的财务服务平台，热门服务推荐：注册公司、代理记账、资质许可、工商代办、税务服务、知识产权代办、系统建设等一站式企业服务。专业团队，品质保障，值得信赖。'
        }
      }
    },
    {
      path: '/xinwen',
      name: 'xinwen',
      component: xinwen,
      // 无 ?id 时 beforeEach 会重定向到 /xueyuan，无独立静态内容，
      // 故不预渲染、不进 sitemap（避免 canonical 不匹配与生产重复页）
      meta: {
        prerender: false,
        sitemap: false,
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|办理许可证',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '名企科技是工商局、财政局批复的财税服务平台，具有政府颁发的《代理记账许可证》资质。公司成立于2017年2月，位于北京市核心区-西城区。公司拥有几十项软件著作权，自主研发名企财务助手小程序，可以协助客户计算税费。公司主要业务有：工商注册、代理记账、工商变更、股权变更、注销清算、申请许可证、申请资质、商标代办、高新企业代理申报、社保服务托管、网站建设等服务。'
        }
      }
    },
    {
      path: '/news/:id',
      name: 'news-detail',
      component: xinwen,
      meta: {
        title: '名企科技-北京代理记账|注册公司|注册营业执照|变更注销|工商代办|办理许可证',
        content: {
          keywords: '注册地址、工商代办业务、注册营业执照、代理记账报税、代办许可、代办资质、工商变更、税务变更、社保托管服务',
          description: '名企科技是工商局、财政局批复的财税服务平台，具有政府颁发的《代理记账许可证》资质。公司成立于2017年2月，位于北京市核心区-西城区。公司拥有几十项软件著作权，自主研发名企财务助手小程序，可以协助客户计算税费。公司主要业务有：工商注册、代理记账、工商变更、股权变更、注销清算、申请许可证、申请资质、商标代办、高新企业代理申报、社保服务托管、网站建设等服务。'
        }
      }
    },
    {
      path: '/caiwuzhushou',
      name: 'caiwuzhushou',
      component: caiwuzhushou,
      meta: {
        title: '财务助手_名企财务助手小程序_企业财税工具_名企科技',
        content: {
          keywords: '财务助手,名企财务助手,财税工具,税费计算器,退休年龄计算器,在线合同,发票抬头,电子名片,企业服务小程序',
          description: '名企财务助手小程序整合税费计算、退休年龄计算、公司起名、在线合同、发票抬头、电子名片、待办事项等企业常用功能，为企业客户提供便捷的财税工具和线上服务入口。'
        }
      }
    },
    {
      path: '/Header',
      redirect: '/'
    },
    {
      path: '/Footer',
      redirect: '/'
    },
    {
      path: '/Youshi',
      redirect: '/'
    },
    {
      // 兜底：未匹配路径（如 /index.html、任意无效 URL）统一重定向到首页，
      // 避免 vue-router 无匹配路由时 #app 白屏
      path: '*',
      redirect: '/'
    }
  ]
})

const siteOrigin = 'https://mingqicaiwu.com'
const defaultShareImage = 'https://mingqicaiwu.com:9001/mingqi/thumbnail.jpg'
const websiteSchemaId = 'website-schema'
const canonicalRouteNames = new Set([
  'index',
  'remen',
  'jizhang',
  'gongshang',
  'shuiwu',
  'zhichan',
  'xuke',
  'renshi',
  'xueyuan',
  'xinxi',
  'zhidu',
  'caiwuzhushou',
  'contact',
  'xinwen',
  'news-detail'
])
const breadcrumbSchemaId = 'breadcrumb-schema'
const breadcrumbRouteMap = {
  remen: [
    { name: '首页', item: `${siteOrigin}/` },
    { name: '热门服务', item: `${siteOrigin}/remen` }
  ],
  jizhang: [
    { name: '首页', item: `${siteOrigin}/` },
    { name: '代理记账', item: `${siteOrigin}/jizhang` }
  ],
  gongshang: [
    { name: '首页', item: `${siteOrigin}/` },
    { name: '工商服务', item: `${siteOrigin}/gongshang` }
  ],
  shuiwu: [
    { name: '首页', item: `${siteOrigin}/` },
    { name: '税务服务', item: `${siteOrigin}/shuiwu` }
  ],
  zhichan: [
    { name: '首页', item: `${siteOrigin}/` },
    { name: '知识产权', item: `${siteOrigin}/zhichan` }
  ],
  xuke: [
    { name: '首页', item: `${siteOrigin}/` },
    { name: '资质许可', item: `${siteOrigin}/xuke` }
  ],
  renshi: [
    { name: '首页', item: `${siteOrigin}/` },
    { name: '人事社保', item: `${siteOrigin}/renshi` }
  ],
  xueyuan: [
    { name: '首页', item: `${siteOrigin}/` },
    { name: '老板学院', item: `${siteOrigin}/xueyuan` }
  ],
  xinxi: [
    { name: '首页', item: `${siteOrigin}/` },
    { name: '软件开发', item: `${siteOrigin}/xinxi` }
  ],
  zhidu: [
    { name: '首页', item: `${siteOrigin}/` },
    { name: '管理咨询', item: `${siteOrigin}/zhidu` }
  ],
  contact: [
    { name: '首页', item: `${siteOrigin}/` },
    { name: '联系我们', item: `${siteOrigin}/contact` }
  ],
  caiwuzhushou: [
    { name: '首页', item: `${siteOrigin}/` },
    { name: '财务助手', item: `${siteOrigin}/caiwuzhushou` }
  ]
}

function getCanonicalHref(to) {
  if (!canonicalRouteNames.has(to.name)) {
    return ''
  }

  if (to.name === 'index') {
    return `${siteOrigin}/`
  }

  if (to.name === 'xinwen') {
    const id = to.query && to.query.id
    if (!id) {
      return `${siteOrigin}/xueyuan`
    }

    return `${siteOrigin}/news/${encodeURIComponent(id)}`
  }

  if (to.name === 'news-detail') {
    return `${siteOrigin}/news/${encodeURIComponent(to.params.id)}`
  }

  return `${siteOrigin}${to.path}`
}

function updateCanonicalLink(href) {
  const canonicalLinks = document.head.querySelectorAll('link[rel="canonical"]')
  let canonicalLink = canonicalLinks[0] || null

  for (let i = 1; i < canonicalLinks.length; i += 1) {
    canonicalLinks[i].remove()
  }

  if (!href) {
    if (canonicalLink) {
      canonicalLink.remove()
    }
    return
  }

  if (!canonicalLink) {
    canonicalLink = document.createElement('link')
    canonicalLink.setAttribute('rel', 'canonical')
    document.head.appendChild(canonicalLink)
  }

  canonicalLink.setAttribute('href', href)
}

function updateMetaTag(selector, attributeName, attributeValue, content) {
  let meta = document.head.querySelector(selector)
  if (!meta) {
    meta = document.createElement('meta')
    meta.setAttribute(attributeName, attributeValue)
    document.head.appendChild(meta)
  }

  meta.setAttribute('content', content)
}

function updateOpenGraphMeta(to) {
  const title = to.meta && to.meta.title ? to.meta.title : '名企科技'
  const description = to.meta && to.meta.content && to.meta.content.description
    ? to.meta.content.description
    : '名企科技提供代理记账、工商注册、税务服务、资质许可、人事社保、知识产权、软件开发等企业服务。'
  const url = getCanonicalHref(to) || `${siteOrigin}${to.path}`

  updateMetaTag('meta[property="og:type"]', 'property', 'og:type', 'website')
  updateMetaTag('meta[property="og:site_name"]', 'property', 'og:site_name', '名企科技')
  updateMetaTag('meta[property="og:locale"]', 'property', 'og:locale', 'zh_CN')
  updateMetaTag('meta[property="og:title"]', 'property', 'og:title', title)
  updateMetaTag('meta[property="og:description"]', 'property', 'og:description', description)
  updateMetaTag('meta[property="og:url"]', 'property', 'og:url', url)
  updateMetaTag('meta[property="og:image"]', 'property', 'og:image', defaultShareImage)
  updateMetaTag('meta[name="twitter:card"]', 'name', 'twitter:card', 'summary_large_image')
  updateMetaTag('meta[name="twitter:title"]', 'name', 'twitter:title', title)
  updateMetaTag('meta[name="twitter:description"]', 'name', 'twitter:description', description)
  updateMetaTag('meta[name="twitter:image"]', 'name', 'twitter:image', defaultShareImage)
}

function updateWebsiteSchema() {
  let script = document.getElementById(websiteSchemaId)
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '名企科技',
    alternateName: '北京名企科技有限公司',
    url: `${siteOrigin}/`
  }

  if (!script) {
    script = document.createElement('script')
    script.id = websiteSchemaId
    script.type = 'application/ld+json'
    document.head.appendChild(script)
  }

  script.textContent = JSON.stringify(schema)
}

function getBreadcrumbItems(to) {
  if (breadcrumbRouteMap[to.name]) {
    return breadcrumbRouteMap[to.name]
  }

  if (to.name === 'xinwen' || to.name === 'news-detail') {
    const id = (to.params && to.params.id) || (to.query && to.query.id)
    if (!id) {
      return []
    }

    return [
      { name: '首页', item: `${siteOrigin}/` },
      { name: '老板学院', item: `${siteOrigin}/xueyuan` },
      { name: '知识详情', item: `${siteOrigin}/news/${encodeURIComponent(id)}` }
    ]
  }

  return []
}

function updateBreadcrumbSchema(items) {
  let script = document.getElementById(breadcrumbSchemaId)

  if (!items.length) {
    if (script) {
      script.remove()
    }
    return
  }

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.item
    }))
  }

  if (!script) {
    script = document.createElement('script')
    script.id = breadcrumbSchemaId
    script.type = 'application/ld+json'
    document.head.appendChild(script)
  }

  script.textContent = JSON.stringify(schema)
}

router.beforeEach((to, from, next) => {
  if (to.name === 'xinwen') {
    if (to.query && to.query.id) {
      next({
        name: 'news-detail',
        params: { id: to.query.id },
        replace: true
      })
      return
    }

    next({
      name: 'xueyuan',
      replace: true
    })
    return
  }

  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.meta.content) {
    const descriptionMeta = document.querySelector('meta[name="description"]')
    if (descriptionMeta) {
      descriptionMeta.setAttribute('content', to.meta.content.description)
    } else {
      const newDescriptionMeta = document.createElement('meta')
      newDescriptionMeta.setAttribute('name', 'description')
      newDescriptionMeta.setAttribute('content', to.meta.content.description)
      document.head.appendChild(newDescriptionMeta)
    }

    const keywordsMeta = document.querySelector('meta[name="keywords"]')
    if (keywordsMeta) {
      keywordsMeta.setAttribute('content', to.meta.content.keywords)
    } else {
      const newKeywordsMeta = document.createElement('meta')
      newKeywordsMeta.setAttribute('name', 'keywords')
      newKeywordsMeta.setAttribute('content', to.meta.content.keywords)
      document.head.appendChild(newKeywordsMeta)
    }
  }

  updateCanonicalLink(getCanonicalHref(to))
  updateOpenGraphMeta(to)
  updateWebsiteSchema()
  updateBreadcrumbSchema(getBreadcrumbItems(to))

  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js